'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useSelectTypeUrl } from '@marketplace-web/domain/identity'
import { useSession } from '@marketplace-web/shared/session-data'

import { ClickableElement } from 'constants/tracking/clickable-elements'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ITEM_UPLOAD_URL, SIGNUP_URL } from 'constants/routes'

const PrimaryButton = () => {
  const { track } = useTracking()
  const translate = useTranslate()
  const { user } = useSession()
  const isNonNativeFlowAbTestEnabled = useAbTest('non_native_flow')?.variant === 'on'
  const selectTypeUrl = useSelectTypeUrl()
  const primaryActionUrl = user?.id
    ? ITEM_UPLOAD_URL
    : urlWithParams(isNonNativeFlowAbTestEnabled ? selectTypeUrl : SIGNUP_URL, {
        ref_url: ITEM_UPLOAD_URL,
      })

  function trackTitleClick() {
    const trackData = {
      target: ClickableElement.UploadItem,
      targetDetails: 'Landing page banner Sell now',
    }

    track(clickEvent(trackData))
  }

  return (
    <Button
      text={translate('homepage.seller_promotion.actions.start')}
      url={primaryActionUrl}
      styling={Button.Styling.Filled}
      onClick={trackTitleClick}
    />
  )
}

export default PrimaryButton
